import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Form} from 'components/ui-kit/Form';
import {Hint} from 'components/ui-kit/Hint';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {Title} from 'components/ui-kit/Title';
import {breakpoint, colors} from 'theme';

export const CustomContentContainer = styled(ContentContainer)`
    display: flex;
    flex-flow: column nowrap;
    flex: 1;
    padding: 10px 15px 15px 15px;
    background-color: ${colors.white};
    border-radius: 8px;

    @media (min-width: ${breakpoint.tablet}) {
        padding: 15px 30px 30px 30px;
    }
`;

export const CustomTitle = styled(Title)`
    color: #59606a;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 40px;
`;

export const Heading = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    margin-bottom: 40px;
    color: #59606a;
    font-weight: 500;
    font-size: 18px;

    @media (min-width: ${breakpoint.phone}) {
        flex-flow: row wrap;
    }
`;

export const FormRoot = styled(Form)`
    display: flex;
    flex-flow: column wrap;
`;

export const FormFields = styled.div<{customGrid?: string}>`
    display: grid;
    grid-row-gap: 10px;
    grid-column-gap: 30px;
    margin-bottom: 20px;

    @media (min-width: ${breakpoint.tablet}) {
        grid-template-columns: ${(p) => p.customGrid ?? '1fr 1fr 1fr'};
    }
`;
export const Actions = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    gap: 16px;
`;

export const SubmitButton = styled(Button)`
    max-width: fit-content;
`;

export const AddButton = styled(Button)`
    max-width: fit-content;
`;

export const BackButton = styled(Button)`
    max-width: fit-content;
    text-decoration: none;
`;

export const Field = styled(Hint)`
    display: flex;
    flex-flow: column wrap;

    > span {
        font-size: 12px;
        color: ${colors.textSecondary};
        padding-bottom: 6px;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 20px;
    justify-content: flex-end;
    align-items: center;

    & > * {
        width: fit-content;
    }
`;
